import axios from 'axios';

// Use environment variable in production, fallback to relative path
const API_BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL + '/api'
  : '/api';

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;

export const authAPI = {
  checkPostcode: (postcode) => axios.post('/auth/check-postcode', { postcode }),
  login: (email, password) => axios.post('/auth/login', { email, password }),
  register: (userData) => axios.post('/auth/register', userData)
};

export const subscriptionsAPI = {
  getPricing: () => axios.get('/subscriptions/pricing'),
  create: (subscriptionData) => axios.post('/subscriptions/create', subscriptionData),
  getMySubscriptions: () => axios.get('/subscriptions/my-subscriptions'),
  cancel: (id) => axios.put(`/subscriptions/${id}/cancel`)
};

export const ordersAPI = {
  getPricing: () => axios.get('/orders/pricing'),
  create: (orderData) => axios.post('/orders/create', orderData),
  getMyOrders: () => axios.get('/orders/my-orders'),
  getOrder: (id) => axios.get(`/orders/${id}`)
};

export const adminAPI = {
  // Overview + schedule
  getDashboard: () => axios.get('/admin/dashboard'),
  getSchedule: (date) => axios.get('/admin/schedule', { params: date ? { date } : {} }),

  // Listings
  getOrders: () => axios.get('/admin/orders'),
  getSubscriptions: () => axios.get('/admin/subscriptions'),
  getCustomers: () => axios.get('/admin/customers'),

  // Orders
  updateOrder: (id, payload) => axios.put(`/admin/orders/${id}/status`, payload),
  createOrder: (orderData) => axios.post('/admin/orders', orderData),

  // Pricing management
  getPricing: () => axios.get('/admin/pricing'),
  addPricing: (data) => axios.post('/admin/pricing', data),
  updatePricing: (id, data) => axios.put(`/admin/pricing/${id}`, data),
  deletePricing: (id) => axios.delete(`/admin/pricing/${id}`),

  // Service-area management
  getServiceAreas: () => axios.get('/admin/service-areas'),
  addServiceArea: (data) => axios.post('/admin/service-areas', data),
  updateServiceArea: (id, data) => axios.put(`/admin/service-areas/${id}`, data),
  deleteServiceArea: (id) => axios.delete(`/admin/service-areas/${id}`),

  // Settings
  getSettings: () => axios.get('/admin/settings'),
  updateSettings: (data) => axios.put('/admin/settings', data)
};

const api = {
  authAPI,
  subscriptionsAPI,
  ordersAPI,
  adminAPI
};

export default api;
